import { ValueFormat, ElementType } from '@/typings/designStudio/sourceElementTypes';
import { getElementType } from '@/utils/elementTypeUtils';
import { parsePatternConfig, enumerateCells } from '@/utils/textPatternEffects';
import * as mapUtils from './mapUtils';

export const setAllTargetsFromSource = (canvas, source) => {
    if (!canvas || !source) return;
    const targets = canvas.getTargetElements(source.uuid);
    targets.forEach((target) => {
        const { targetElement, valueFormat } = target;
        if (!targetElement || !valueFormat) return;
        setTargetFromSource(source, targetElement, valueFormat);
    });
};

export const setTargetFromSource = (source, target, valueFormat) => {
    if (!source || !target || !valueFormat) return;

    let valueToSet = '';
    const sourceType = getElementType(source);
    //For now, only maps are supported as source elements
    if (sourceType === ElementType.Map) {
        const config = typeof source.mapConfig == 'string' ? JSON.parse(source.mapConfig) : source.mapConfig;
        const { longitude, latitude } = config;
        if (valueFormat === ValueFormat.MapCoordinatesDMS) {
            valueToSet = mapUtils.getMapCoordinates(latitude, longitude).dms;
        } else {
            valueToSet = mapUtils.getMapCoordinates(latitude, longitude).dd;
        }
    }

    const targetType = getElementType(target);
    //For now, only text elements are supported as target elements
    if (targetType === ElementType.Text) {
        target.setText(valueToSet);
    }
};

export const populateElementsLinks = (elementsLinks, canvas, TextService = null) => {
    if (!elementsLinks || !canvas) return;

    populatePatternLinks(elementsLinks, canvas);

    for (const link of elementsLinks) {
        const targetElement = canvas.getObjects().find((obj) => obj.uuid === link.targetId);
        const sourceElement = canvas.getObjects().find((obj) => obj.uuid === link.sourceId);
        if (!targetElement || !sourceElement) continue;

        if (link.valueFormat === ValueFormat.TextAsMask) {
            targetElement.hasTextMask = true;
            if (TextService) TextService.addObjectWithTextMask(sourceElement.uuid, targetElement);
            continue;
        }

        if (link.valueFormat === ValueFormat.TextAsCutout) {
            targetElement.hasTextMask = true;
            if (TextService) TextService.addObjectWithTextCutout(sourceElement.uuid, targetElement);
            continue;
        }

        if (link.valueFormat === ValueFormat.Pattern) {
            continue;
        }

        canvas.addLinkElements(link.sourceId, targetElement, link.sourceType, link.valueFormat);
        targetElement.sourceElement = {
            sourceId: link.sourceId,
            sourceType: link.sourceType,
            valueFormat: link.valueFormat
        };
        setTargetFromSource(sourceElement, targetElement, link.valueFormat);
    }
};

const populatePatternLinks = (elementsLinks, canvas) => {
    const patternLinks = elementsLinks.filter((link) => link.valueFormat === ValueFormat.Pattern);
    if (!patternLinks.length) return;

    const linksByOrigin = new Map();
    for (const link of patternLinks) {
        if (!linksByOrigin.has(link.sourceId)) linksByOrigin.set(link.sourceId, []);
        linksByOrigin.get(link.sourceId).push(link);
    }

    for (const [originId, links] of linksByOrigin) {
        const origin = canvas.getObjects().find((obj) => obj.uuid === originId);
        if (!origin) continue;

        const config = parsePatternConfig(origin.patternConfig);
        origin.pattern = true;
        origin.patternConfig = config;
        const cells = config ? enumerateCells(config) : [];

        links.forEach((link, index) => {
            const replica = canvas.getObjects().find((obj) => obj.uuid === link.targetId);
            if (!replica) return;
            replica.isPatternReplica = true;
            replica.patternOriginUuid = originId;
            replica.set('locked', true);
            if (replica._backupStroke !== undefined && replica.setStroke) {
                replica.setStroke(replica._backupStroke);
            }
            if (cells[index]) {
                replica.patternCell = { row: cells[index].row, col: cells[index].col };
            }
        });
    }
};
